type Row = Record<string, unknown>;

function ymd10(s: unknown): string {
  const raw = String(s ?? "").trim();
  return /^\d{4}-\d{2}-\d{2}/.test(raw) ? raw.slice(0, 10) : "";
}

function addCalendarDays(ymd: string, delta: number): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  const [y, m, d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return null;
  const u = Date.UTC(y, m - 1, d + delta);
  const dt = new Date(u);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

function maxYmd(a: string, b: string): string {
  return a >= b ? a : b;
}

export type AnnounceTimingBanner = {
  kind: "before_reception" | "before_deadline" | "three_days_before_show";
  message: string;
};

/**
 * 告知カード用：今日（JST・YYYY-MM-DD）が受付前／締切前／開催3日前に当たるときの注意文。
 * 表掲載（public）の行だけ。
 */
export function announceTimingBannersForRow(today: string, e: Row): AnnounceTimingBanner[] {
  if (String(e.visibility ?? "").trim().toLowerCase() !== "public") return [];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(today)) return [];

  const rs = ymd10(e.reception_start);
  const re = ymd10(e.reception_end);
  const ev = ymd10(e.event_date);
  const out: AnnounceTimingBanner[] = [];

  if (rs && today < rs) {
    out.push({
      kind: "before_reception",
      message: `受付前です（受付開始: ${rs}）`,
    });
  }

  if (rs && re && today >= rs && today <= re) {
    const twoDaysBeforeClose = addCalendarDays(re, -2);
    const phaseStart = twoDaysBeforeClose ? maxYmd(rs, twoDaysBeforeClose) : rs;
    if (today >= phaseStart) {
      out.push({
        kind: "before_deadline",
        message: `締め切り前です（受付終了: ${re}）`,
      });
    }
  }

  if (ev) {
    const d3 = addCalendarDays(ev, -3);
    if (d3 && today === d3) {
      out.push({
        kind: "three_days_before_show",
        message: `開催の3日前です（開催日: ${ev}）`,
      });
    }
  }

  return out;
}
